import { initializeApp, setLogLevel } from "firebase/app";
import {removeAll} from "./lib/localStorage";

setLogLevel('debug');
const firebaseConfig = {
  apiKey: "AIzaSyDuEae2b2zXu_om7ddE-iOlVxYL02kbI_M",
  authDomain: "forum-labs-416414.firebaseapp.com",
  databaseURL: "https://forum-labs-416414-default-rtdb.firebaseio.com",
  projectId: "forum-labs-416414",
  storageBucket: "forum-labs-416414.firebasestorage.app",
  messagingSenderId: "366531564300",
  appId: "1:366531564300:web:7c26411942e6b328af6f29",
  measurementId: "G-4E1PJTEDLS"
};

export const initializeFirebase = () => {
  initializeApp(firebaseConfig);
  setLogLevel('debug');
  const currentLocalVersion = 7;
  const storageVersion = localStorage.getItem("localversion");
  if (storageVersion !== currentLocalVersion.toString()) {
    removeAll();
    localStorage.setItem("localversion", currentLocalVersion.toString());
  }

  localStorage.setItem('firebase:debug', 'true');
}